import React, { FC, useRef, useState } from 'react'
import { CommonAPI } from '@api/index'
import i18n from 'i18next'
import { toast } from '@utils'
import { each } from '@dt/fe-utils/dist/lodash'
import { uuid } from '@dt/fe-utils'
import './index.scss'

const { BRANDID } = Config

interface IProps {
  len: number;
  max: number;
  onChange?: (url: any[]) => void;
}

interface IState {
}

const UploadInput: FC<IProps> = (props: IProps) => {
  const { max, len, onChange } = props
  const inputEl = useRef<any>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const onUplaod = () => {
    if (loading) return
    const i = inputEl.current
    if (i.files.length && i.files.length > max - len) {
      toast({ message: i18n.t('mkt.common.fileLimitTip', { limit: max - len }) })
      return
    }
    if (i.files.length) {
      setLoading(true)
      const promistList = []
      each(i.files, (item: any) => {
        const fData = new FormData()
        fData.append('file', item)
        fData.append('uuid', uuid())
        fData.append('type', 'image')
        promistList.push(CommonAPI.uploadImg(fData))
      })
      Promise.allSettled(promistList).then((resList: any[]) => {
        const succList = resList.reduce((prev, item) => item.status === 'fulfilled' && item?.value?.result?.content ? [...prev, item.value.result.content?.[0]] : prev, []) || []
        if (succList.length > 0) {
          onChange && onChange(succList)
          if (succList.length < resList.length) {
            toast({ message: i18n.t('mkt.common.uploadFailSome') })
          }
        } else {
          toast({ message: i18n.t('mkt.common.uploadFail') })
        }
      }).finally(() => {
        setLoading(false)
      })
    }
  }
  return (
    <div className='mkt-upload-input'>
      <i className='iconfont icon-camera'></i>
      <span>{loading ? `${i18n.t('common.uploading')}...` : len > 0 ? `${len}/${max}` : i18n.t('mkt.common.uploadPhotos')}</span>
      <input
        ref={inputEl}
        multiple
        type='file'
        maxLength={6}
        accept='image/gif,image/jpeg,image/png,image/bmp'
        data-cypid='mtkUploadInput'
        onClick={(e: any) => {
          e.target.value = null
        }}
        onChange={onUplaod}
      >
      </input>
    </div>
  )
}

export default UploadInput
